import { use, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

import {
  addToCart,
  isInCart,
  updateCartItemQuantity,
  getCartQuantity,
  getCart,
  getUser,
} from "../../utils/cart";
import { useEffect, useDebugValue } from "react";

import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
  Authorization_Token,
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";

interface Address {
  id: number;
  type: string;
  name: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  isDefault: boolean;
}

export default function MyAddressesPage() {
  const navigate = useNavigate();
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const { logindata, setlogindata, userData, setuserData } = context;

  const [addresses, setAddresses] = useState<Address[]>([
    {
      id: 1,
      type: "Home",
      name: "Rahul Sharma",
      phone: "+91 98765 43210",
      address: "123 Green Valley Road, Andheri West",
      city: "Mumbai",
      state: "Maharashtra",
      pincode: "400058",
      isDefault: true,
    },
    {
      id: 2,
      type: "Office",
      name: "Rahul Sharma",
      phone: "+91 98765 43210",
      address: "Tower B, 5th Floor, Tech Park, Powai",
      city: "Mumbai",
      state: "Maharashtra",
      pincode: "400076",
      isDefault: false,
    },
    {
      id: 3,
      type: "Other",
      name: "Priya Sharma",
      phone: "+91 87654 32109",
      address: "45 Rose Garden Apartments, Bandra East",
      city: "Mumbai",
      state: "Maharashtra",
      pincode: "400051",
      isDefault: false,
    },
  ]);
  const [loading, setLoading] = useState(true);

  const [AddressData, setAddressesData] = useState([]);
  const [addressNickName, setAddressNickName] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [cityID, setCityID] = useState("");
  const [state, setState] = useState("");
  const [stateID, setStateID] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [country, setCountry] = useState("");
  const [addressType, setAddressType] = useState("Home");
  const [contactName, setContactName] = useState("");
  const [contactMobile, setContactMobile] = useState("");
  const [userMobile, setUserMobile] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [IsBilling, setIsBilling] = useState(false);
  const [formData, setFormData] = useState({
    type: "Home",
    name: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  });

  useEffect(() => {
    // const userData = getUser();

    getAddress();
    window.scrollTo(0, 0);
  }, []);

  const handleOpenModal = (address?: any, isBilling: boolean = false) => {
    if (address) {
      setEditingAddress(address);

      if (isBilling == true) {
        setIsBilling(true);
        setPincode(address.Pincode);
        setCity(address.City);
        setState(address.State);
        setContactName(address.LedgerName);
        setContactMobile(address.SignInMobile);

        setAddressLine1(address.Address);
        setCityID(address.CityID);
        setStateID(address.StateID);
        setStateCode(address.StateCode);
        setCountry(address.Country);
      } else {
        setIsBilling(false);
        setPincode(address.Pincode);
        setCity(address.City);
        setState(address.State);
        setContactName(address.Email);
        setContactMobile(address.Phone);

        setAddressLine1(address.Address);
        setCityID(address.CityID);
        setStateID(address.StateID);
        setStateCode(address.StateCode);
        setCountry(address.Country);
        setAddressType(address.AddressType);
      }
    } else {
      setEditingAddress(null);
      setPincode("");
      setCity("");
      setState("");
      setAddressLine1("");
      setCityID("");
      setStateID("");
      setStateCode("");
      setCountry("");
      setAddressType("");
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingAddress(null);
  };

  const handleSaveAddress = () => {
    let AddressBody = null;

    if (IsBilling === true) {
      AddressBody = [
        {
          LedgerID: editingAddress?.LedgerID,
          // AddressNickName: contactName,
          Address: addressLine1,
          Pincode: pincode,
          City: city,
          CityID: cityID,
          State: state,
          StateID: stateID,
          StateCode: stateCode,
          Country: country,
          // AddressType: addressType,
          ContactName: contactName,
          // ContactMobile: contactMobile,
          //  UserMobile: userData?.SignInMobile,
        },
      ];
    } else {
      AddressBody = [
        {
          ...(editingAddress && { SiteID: editingAddress.SiteID }),
          Email: contactName,
          Address: addressLine1,
          Pincode: pincode,
          City: city,
          CityID: cityID,
          State: state,
          StateID: stateID,
          StateCode: stateCode,
          Country: country,
          AddressType: addressType,
          ContactName: contactName,
          Phone: contactMobile,
          UserMobile: userData?.SignInMobile,
          Distributor : userData?.LedgerName,
          DistributorID : userData?.LedgerID,
          Site : `${addressLine1} Site`
        },
      ];
    }

    PostRecords(!IsBilling ? 3406 : 1452, 1, AddressBody, (response: any) => {
      if (response.hasErrors === false) {
        if (!IsBilling) {
          getAddress();
        } else {
          const updatedUser = {
            ...userData,
            City: city,
            CityID: cityID,
            State: state,
            StateID: stateID,
            StateCode: stateCode,
            Country: country,
            ContactName: contactName,
            Address: addressLine1,
            Pincode: pincode,
          };

          setuserData(updatedUser);
          localStorage.setItem(
            "UserData-UniversalDairy",
            JSON.stringify(updatedUser),
          );
        }

        handleCloseModal();
      } else {
        alert(response.errors);
      }
    });
  };



  const getAddressIcon = (type: string) => {
    switch (type) {
      case "Home":
        return "ri-home-4-line";
      case "Office":
        return "ri-building-line";
      default:
        return "ri-map-pin-line";
    }
  };

  const getAddress = () => {
    const userData: any = getUser();
    if (contactMobile === "" && contactName === "") {
      setContactMobile(userData?.SignInMobile);
      setContactName(userData?.LedgerName);
    }

    getRecords(
      3406,
      100,
      -1,
      `{DistributorID: { $in: [${userData?.LedgerID}] }}`,
      1,
      "",
      (data: any) => {
        // console.log("user details response", response);

        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records.length > 0) {
            setAddressesData(data?.response?.records || []);

            setLoading(false);
          } else {
            setLoading(false);
            console.log("Error in fetching categories", data);
          }
        } else {
          setLoading(false);
        }
      },
    );
  };

  const getPinData = (pinCode: any) => {
    const url = `${BaseUrl}/api/dynamic/AutoFillMapperWise?tabErpID=1760&tabName=Delivery%20Addresses`;
    const body = {
      depth: 10,
      accessRight: 0,
      useRegexSearch: false,
      useAtlusSearch: false,
      userID: 1002,
      filters: "{tabErpID:1760}",
      index: 1,
      isDownload: false,
      columnName: "Pincode",
      toEmailID: "it.manager@ananda.in",
      tabErpID: 1760,
      isUpdate: false,
      dataMapper: {
        CollectionName: "FINANCECONNECT_Pincode",
        filter: `{'Pincode':${pinCode}}`,
        project:
          "{'Pincode':'$Pincode','City':'$City','CityID':'$CityID','StateID':'$StateID','State':'$State','StateCode':'$StateCode','Country':'$Country'}",
        suggestedText: "",
      },
    };

    callApi(
      url,
      body,
      Authorization_Token,
      (response: any) => {
        if (
          response?.hasErrors == false && response?.response?.records!=null && 
          response?.response?.records.length > 0
        ) {
          const data = response?.response?.records[0];

          setCity(data?.City);
          setCityID(data?.CityID);
          setState(data?.State);
          setStateID(data?.StateID);
          setStateCode(data?.StateCode);
          setCountry(data?.Country);
        } else {
          alert("Please enter a valid pincode.");
            setCity("");
          setCityID("");
          setState("");
          setStateID("");
          setStateCode("");
          setCountry("");
        }
      },
      (error: any) => {},
    );
  };

  const handleDelete = (id: number) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this address?",
    );

    if (!confirmDelete) return;

    const url = `${BaseUrl}/api/dynamic/DeleteRecords?tabErpID=3406&tabName=Delivery%20Addresses`;

    const body = {
      userID: userData?.LedgerID,
      srs: id,
      deleteALL: false,
      tabErpID: 3406,
      processID: 1,
    };

    callApi(
      url,
      body,
      Authorization_Token,
      (response: any) => {
        if (response?.hasErrors == false && response != null) {
          alert("Address deleted successfully.");
          getAddress();
        } else {
          alert(response?.errors);
        }
      },
      (error: any) => {
        alert("Something went wrong while deleting.");
      },
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <main className="pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm mb-8">
            <Link to="/" className="text-gray-500 hover:text-amber-600">
              Home
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <Link to="/profile" className="text-gray-500 hover:text-amber-600">
              Profile
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900 font-medium">My Addresses</span>
          </nav>

          {/* Header */}
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                My Billing Address
              </h1>
              <p className="text-gray-500 mt-1">Manage your addresses</p>
            </div>
            {/* <button
              onClick={() => handleOpenModal()}
              className="flex items-center gap-2 px-5 py-2.5 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-add-line text-lg"></i>
              Add New Address
            </button> */}
          </div>

          {/* Address Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div
              className={`bg-white rounded-xl shadow-sm border-2 transition-all ${
                false
                  ? "border-amber-500"
                  : "border-transparent hover:border-gray-200"
              }`}
            >
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center ${
                        true ? "bg-amber-100" : "bg-gray-100"
                      }`}
                    >
                      <i
                        className={`${getAddressIcon(userData?.AddressType)} text-lg ${
                          true ? "text-amber-600" : "text-gray-600"
                        }`}
                      ></i>
                    </div>
                    <div>
                      {/* <span
                          className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                            true
                              ? "bg-amber-100 text-amber-700"
                              : "bg-gray-100 text-gray-600"
                          }`}
                        >
                          {userData?.AddressType}
                        </span> */}
                      {/* {address.isDefault && (
                          <span className="ml-2 text-xs text-amber-600 font-medium">Default</span>
                        )} */}
                    </div>
                  </div>
                  <div className="flex items-center gap-1">
                    <button
                      onClick={() => handleOpenModal(userData, true)}
                      className="p-2 text-gray-400 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors cursor-pointer"
                    >
                      <i className="ri-edit-line text-lg"></i>
                    </button>
                    {/* <button
                        onClick={() => handleDeleteAddress(userData.id)}
                        className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
                      >
                        <i className="ri-delete-bin-line text-lg"></i>
                      </button> */}
                  </div>
                </div>

                <div className="space-y-2">
                  <p className="font-semibold text-gray-900">
                    {userData?.LedgerName}
                  </p>
                  <p className="text-gray-600 text-sm">{userData?.Address}</p>
                  <p className="text-gray-600 text-sm">
                    {userData?.City}, {userData?.State} - {userData?.Pincode}
                  </p>
                  <p className="text-gray-600 text-sm flex items-center gap-2">
                    <i className="ri-phone-line"></i>
                    {userData?.SignInMobile}
                  </p>
                </div>
                {/* 
                  {!address.isDefault && (
                    <button
                      onClick={() => handleSetDefault(address.id)}
                      className="mt-4 text-sm text-amber-600 hover:text-amber-700 font-medium cursor-pointer"
                    >
                      Set as Default
                    </button>
                  )} */}
              </div>
            </div>

            {/* Add New Address Card */}
            {/* <button
              onClick={() => handleOpenModal()}
              className="bg-white rounded-xl border-2 border-dashed border-gray-300 hover:border-amber-500 transition-colors cursor-pointer min-h-[200px] flex flex-col items-center justify-center gap-3"
            >
              <div className="w-14 h-14 bg-amber-50 rounded-full flex items-center justify-center">
                <i className="ri-add-line text-2xl text-amber-600"></i>
              </div>
              <span className="text-gray-600 font-medium">Add New Address</span>
            </button> */}
          </div>

          <div style={{ height: 40 }}></div>

          {/* Header */}
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                My Delivery Addresses
              </h1>
              <p className="text-gray-500 mt-1">Manage your addresses</p>
            </div>
            <button
              onClick={() => handleOpenModal()}
              className="flex items-center gap-2 px-5 py-2.5 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-add-line text-lg"></i>
              Add New Address
            </button>
          </div>

          {/* Address Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {AddressData?.map((address, i) => (
              <div
                key={address._id}
                className={`bg-white rounded-xl shadow-sm border-2 transition-all ${
                  false
                    ? "border-amber-500"
                    : "border-transparent hover:border-gray-200"
                }`}
              >
                <div className="p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-10 h-10 rounded-full flex items-center justify-center ${
                          true ? "bg-amber-100" : "bg-gray-100"
                        }`}
                      >
                        <i
                          className={`${getAddressIcon(address.AddressType)} text-lg ${
                            true ? "text-amber-600" : "text-gray-600"
                          }`}
                        ></i>
                      </div>
                      <div>
                        {/* <span
                          className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                            true
                              ? "bg-amber-100 text-amber-700"
                              : "bg-gray-100 text-gray-600"
                          }`}
                        >
                          {address.AddressType}
                        </span> */}
                        {/* {address.isDefault && (
                          <span className="ml-2 text-xs text-amber-600 font-medium">Default</span>
                        )} */}
                      </div>
                    </div>
                    <div className="flex items-center gap-1">
                      <button
                        onClick={() => handleOpenModal(address)}
                        className="p-2 text-gray-400 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors cursor-pointer"
                      >
                        <i className="ri-edit-line text-lg"></i>
                      </button>
                      <button
                        onClick={() => handleDelete(address?.SiteID)}
                        className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
                      >
                        <i className="ri-delete-bin-line text-lg"></i>
                      </button>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <p className="font-semibold text-gray-900">
                      {address.Email}
                    </p>
                    <p className="text-gray-600 text-sm">
                      {address.Address}
                    </p>
                    <p className="text-gray-600 text-sm">
                      {address.City}, {address.State} - {address.Pincode}
                    </p>
                    <p className="text-gray-600 text-sm flex items-center gap-2">
                      <i className="ri-phone-line"></i>
                      {address?.Phone}
                    </p>
                  </div>
                  {/* 
                  {!address.isDefault && (
                    <button
                      onClick={() => handleSetDefault(address.id)}
                      className="mt-4 text-sm text-amber-600 hover:text-amber-700 font-medium cursor-pointer"
                    >
                      Set as Default
                    </button>
                  )} */}
                </div>
              </div>
            ))}

            {/* Add New Address Card */}
            <button
              onClick={() => handleOpenModal()}
              className="bg-white rounded-xl border-2 border-dashed border-gray-300 hover:border-amber-500 transition-colors cursor-pointer min-h-[200px] flex flex-col items-center justify-center gap-3"
            >
              <div className="w-14 h-14 bg-amber-50 rounded-full flex items-center justify-center">
                <i className="ri-add-line text-2xl text-amber-600"></i>
              </div>
              <span className="text-gray-600 font-medium">Add New Address</span>
            </button>
          </div>
        </div>
      </main>

      {/* Add/Edit Address Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={handleCloseModal}
          ></div>
          <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white px-6 py-4 border-b border-gray-100 flex items-center justify-between">
              <h2 className="text-xl font-semibold text-gray-900">
                {editingAddress ? "Edit Address" : "Add New Address"}
              </h2>
              <button
                onClick={handleCloseModal}
                className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            <div className="p-6 space-y-5">
              {/* Address Type */}

              {!IsBilling && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Address Type
                  </label>
                  <div className="flex gap-3">
                    {["Home", "Office", "Shop", "Other"].map((type) => (
                      <button
                        key={type}
                        onClick={() => setAddressType(type)}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg border-2 transition-colors cursor-pointer whitespace-nowrap ${
                          addressType === type
                            ? "border-amber-500 bg-amber-50 text-amber-700"
                            : "border-gray-200 text-gray-600 hover:border-gray-300"
                        }`}
                      >
                        <i className={getAddressIcon(type)}></i>
                        {type}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name
                </label>
                <input
                  type="text"
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                  placeholder="Enter full name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                />
              </div>

              {/* Phone */}

              {!IsBilling && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    value={contactMobile}
                    onChange={(e) => setContactMobile(e.target.value)}
                    placeholder="Enter phone number"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                  />
                </div>
              )}

              {/* Address */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Street Address
                </label>
                <textarea
                  value={addressLine1}
                  onChange={(e) => setAddressLine1(e.target.value)}
                  placeholder="Enter street address, building, floor, etc."
                  rows={3}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm resize-none"
                />
              </div>

              {/* Pincode */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  PIN Code
                </label>
                <input
                  type="text"
                  value={pincode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ""); // digits only
                    if (value.length <= 6) {
                      setPincode(value);
                    }

                    if (value.length === 6) {
                      getPinData(value);
                    }
                  }}
                  placeholder="Enter PIN code"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                />
              </div>

              {/* City & State */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    City
                  </label>
                  <input
                    type="text"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    placeholder="Enter city"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    State
                  </label>
                  <input
                    type="text"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    placeholder="Enter state"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                  />
                </div>
              </div>
            </div>

            <div className="sticky bottom-0 bg-white px-6 py-4 border-t border-gray-100 flex gap-3">
              <button
                onClick={handleCloseModal}
                className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Cancel
              </button>
              <button
                disabled={
                  !pincode ||
                  !addressLine1 ||
                  !city ||
                  !state ||
                  !contactMobile ||
                  !contactName
                }
                onClick={() => {
                  handleSaveAddress();
                }}
                className={`flex-1 px-4 py-3 text-white rounded-lg transition-colors whitespace-nowrap
    ${
      !pincode ||
      !addressLine1 ||
      !city ||
      !state ||
      !contactMobile ||
      !contactName
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-amber-600 hover:bg-amber-700 cursor-pointer"
    }`}
              >
                {editingAddress ? "Save Changes" : "Add Address"}
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
